import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Footer from "../components/Footer";

import RedpayLogo from "../assets/images/logos/redpay-small.png";
import { Col, Container, Row } from "reactstrap";
import LanguageSelector from "../components/LanguageSelector";
import { DEFAULT_LANGUAGE, LANGUAGES } from "../Constants";
import { llog } from "../utils/LogUtils";

const ConfirmationPage = () => {
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const languageParam = searchParams.get("lang");
  const langFound = LANGUAGES.find((lang) => lang.lang === languageParam);
  const language = langFound ? languageParam : DEFAULT_LANGUAGE;

  const setLanguage = (lang) => {
    searchParams.set("lang", lang);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    i18n.changeLanguage(language);
    llog("NODE_ENV:" + process.env.NODE_ENV);
    llog("APP_ENV:" + process.env.REACT_APP_ENV);
    llog("BACKEND_URL:" + process.env.REACT_APP_API_BASE_URL);
  }, [language, i18n]);

  return (
    <div className='app-wrapper bg-white min-vh-100'>
      <Container>
        <Row className='my-5 align-items-center'>
          <Col md='10' lg='8'>
            <div>
              <img src={RedpayLogo} alt='Redpay logo' className='mx-2 mb-2' width={200} />
              <strong>{t("welcome")}</strong>
            </div>
          </Col>
          <Col md='2' lg='4' className='text-right'>
            <LanguageSelector language={language} setLanguage={setLanguage} />
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default ConfirmationPage;
